import React from "react";
import Popup from "./manager_popup";
import { withAlert } from "react-alert";

class Tool_Manager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: props.item,
      allperson: 0,
    };
    this.alert = this.props.alert;
  }

  componentDidMount() {
    this.props.count(this);
  }

  openpopup = () => {
    if (!this.props.item) {
      this.alert.show("수정할 열을 선택해 주세요.");
      return;
    }
    document.getElementById("modal").style.display = "block";
  };

  checkdelete() {
    if (document.getElementById("modal").style.display === "block") {
      document.getElementById("modal").style.display = "none";
    } else {
      if (window.confirm("정말로 삭제하시겠습니까?")) {
        // 삭제작업
        this.props.delete();
        this.props.update();
      }
    }
  }

  render() {
    return (
      <>
        <div
          className="tool-box"
          style={{ float: "right", marginBottom: "1%" }}
        >
          {/* 체크박스 선택이 없을시 버튼 클릭 X */}
          <span>총인원 : &nbsp; {this.state.allperson}명　　</span>
          <button
            className="button_delete"
            id="tool-btn delete"
            onClick={this.checkdelete.bind(this)}
          >
            삭제
          </button>
          <button
            className="button_modify"
            id="tool-btn popup"
            onClick={this.openpopup.bind(this)}
          >
            수정
          </button>
        </div>
        <Popup
          item={this.props.item}
          element={this.props.element}
          update={this.props.update}
        />
      </>
    );
  }
}

export default withAlert()(Tool_Manager);
